import { useSelector } from '../../../../store/store'
import ReadEditLead from '../../../../views/Leads/LeadsList/components/ReadEditLead'

export const LeadEnhancedTableToolbar = () => {
  const { open } = useSelector((state) => state.dialog)

  return <>{open && <ReadEditLead />}</>
}
